export const fetchUser = () => {
    return async (dispatch, getState) => {
        try {
            const token = localStorage.getItem("teslaUserAccessToken");

            const res = await fetch('https://teslasafebroker.com/api/userinfo', {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            const data = await res.json();
            const userData = data.user; // ✅ get only the user object

            const currentUser = getState().user;

            if (JSON.stringify(currentUser) !== JSON.stringify(userData)) {
                dispatch({ type: 'SET_USER', payload: userData });
            }
        } catch (err) {
            if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                // ✅ Make sure to check error.response exists first
                localStorage.removeItem("teslaUserAccessToken");
                localStorage.removeItem("teslaUserInfo");
                // Optional: redirect or show login expired message
                window.location.href = "/login";
            } else {
                console.error('Error fetching user info:', err);
            }
        }
    };
};


export const updateUserChat = (chat) => ({
    type: 'UPDATE_USER_CHAT',
    payload: chat,
});